<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador"/><br/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="PROBLEMAS" v-if="veiculo">
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </vk-tabs-item>

            <vk-tabs-item title="VEÍCULO" v-if="veiculo">
                <dados-do-veiculo-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CLIENTE" v-if="cliente">
                <dados-do-cliente-admin :cliente="cliente"/>
            </vk-tabs-item>

            <vk-tabs-item title="RELATÓRIOS" v-if="veiculo">
                <dados-relatorios-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">
                <vk-tabs-vertical>
                    <vk-tabs-item title="IP & PORTA" v-if="config">
                        <ip-tk :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="TEMPOS" v-if="config">
                        <tempos-tk :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="GERAL">
                        <table>
                            <tr class="spaceUnder">
                                <td>Protocolo 18</td>
                                <td style="padding-left: 30px; padding-right: 30px">
                                    <procolo18-out :id_rastreador="rastreador.id_rastreador"/>
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </vk-tabs-item>
                </vk-tabs-vertical>
            </vk-tabs-item>

        </vk-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="COMANDOS">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador"/><br/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>
        </vk-tabs>
    </div>
</template>
<script>
    import {Rastreador, Veiculo} from '../../class/index';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import HeaderAdmin from './HeaderAdmin';
    import IpTk from './partials/tk/IpTk';
    import { Tk } from '../../class/tk';
    import Problemas from "../veiculo/Problemas";
    import TableComandos from "../tables/TableComandos";
    import SolicitarPosicao from "../buttons/SolicitarPosicao";
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import PositionsMaps from './partials/PositionsMaps.vue';
    import DadosDoVeiculoAdmin from './partials/DadosDoVeiculoAdmin.vue';
    import DadosDoClienteAdmin from './partials/DadosDoClienteAdmin.vue';
    import DadosRelatoriosAdmin from './partials/DadosRelatoriosAdmin.vue';
    import BloqueioImediado from '../buttons/BloqueioImediado.vue';
    import TimeZone from '../buttons/TimeZone.vue';
    import BloqueioLento from '../buttons/BloqueioLento.vue';
    import Procolo18Out from '../buttons/Procolo18Out.vue';
    import TemposTk from './partials/tk/TemposTk.vue';
    
    export default {
        components: {
            Procolo18Out,
            DadosRelatoriosAdmin,
            DadosDoClienteAdmin,
            DadosDoVeiculoAdmin,
            PositionsMaps,
            SolicitarPosicao,
            Problemas,
            IpTk,
            TemposTk,
            HeaderAdmin, TableComandos, EnviarSaidas
        },

        data(){
            return {
                config: null,
            }
        },

        mixins: [
            veiculosAdminMixins
        ],

        async beforeMount(){
            this.config = await Tk.byPK(this.rastreador.id_rastreador);
        },

    }
</script>
